import React, { FC } from 'react'
import { Row, UncontrolledTooltip } from 'reactstrap';

export interface AEATitleProps {
    id: string;
    text: string;
    tooltip?: string;
    className?: string;
    placement?: 'auto-start'
    | 'auto'
    | 'auto-end'
    | 'top-start'
    | 'top'
    | 'top-end'
    | 'right-start'
    | 'right'
    | 'right-end'
    | 'bottom-end'
    | 'bottom'
    | 'bottom-start'
    | 'left-end'
    | 'left'
    | 'left-start';
}

const AEATitle: FC<AEATitleProps> = (props: AEATitleProps) => {
    /*main render*/
    return (
        <Row className={props.className}>
            <h5 id={`tooltip-${props.id}`}>{props.text}</h5>
            { props.tooltip ?
            <UncontrolledTooltip placement={props.placement} target={`tooltip-${props.id}`}>
                {props.tooltip}
            </UncontrolledTooltip> : <div></div>
            }
        </Row>
    )
}

export default AEATitle
